/**
 * Interaction Service
 * Handles pure logic functionality and React hooks related to user interactions
 */

import { useState, useCallback } from 'react';

/**
 * Map Point Selection Callback Function Hook
 * @returns {Object} Object containing setter and cleanup functions
 */
export const useMapPointSelect = () => {
  const [mapPointSelectCallback, setMapPointSelectCallback] = useState(null);
  
  // Set map point selection callback with validation
  const setMapPointSelect = useCallback((callback) => {

    // Validate callback is either null or a function
    if (callback !== null && typeof callback !== 'function') {
      console.error(`[DEBUG-HOOK] Invalid callback type provided: ${typeof callback}. Must be a function or null.`);
      return;
    }
    
    setMapPointSelectCallback(() => callback);

  }, []);
  
  // Clear point selection callback
  const clearMapPointSelect = useCallback(() => {

    setMapPointSelectCallback(null);
  }, []);
  
  return {
    mapPointSelectCallback,
    setMapPointSelect,
    clearMapPointSelect
  };
};

/**
 * Check if current mode allows map click to add points
 * @param {string} currentMode - Current mode
 * @param {string} setupSubmode - Setup submode
 * @returns {boolean} Whether clicking to add points is allowed
 */
export const isMapClickAddPointEnabled = (currentMode, setupSubmode) => {
  return currentMode === 'Setup Path Points' && setupSubmode === 'Map Point Marking';
};

/**
 * Check if current mode allows selecting existing points
 * @param {string} currentMode - Current mode
 * @returns {boolean} Whether point selection is allowed
 */
export const isPointSelectionEnabled = (currentMode) => {
  return currentMode === 'Custom Path';
}; 